import React from "react";
import { iconProps } from "../Helper";

export const DateIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M1.86804 17.7611C1.40497 17.7611 1.01302 17.6007 0.692188 17.2798C0.371354 16.959 0.210938 16.567 0.210938 16.104V3.83485C0.210938 3.37178 0.371354 2.97983 0.692188 2.659C1.01302 2.33817 1.40497 2.17775 1.86804 2.17775H3.13717V0.23877H4.54746V2.17775H11.493V0.23877H12.868V2.17775H14.1372C14.6002 2.17775 14.9922 2.33817 15.313 2.659C15.6339 2.97983 15.7943 3.37178 15.7943 3.83485V16.104C15.7943 16.567 15.6339 16.959 15.313 17.2798C14.9922 17.6007 14.6002 17.7611 14.1372 17.7611H1.86804ZM1.86804 16.3861H14.1372C14.2077 16.3861 14.2724 16.3567 14.331 16.2979C14.3899 16.2392 14.4193 16.1746 14.4193 16.104V7.50152H1.58594V16.104C1.58594 16.1746 1.61535 16.2392 1.67417 16.2979C1.73283 16.3567 1.79746 16.3861 1.86804 16.3861ZM1.58594 6.12652H14.4193V3.83485C14.4193 3.76427 14.3899 3.69964 14.331 3.64098C14.2724 3.58216 14.2077 3.55275 14.1372 3.55275H1.86804C1.79746 3.55275 1.73283 3.58216 1.67417 3.64098C1.61535 3.69964 1.58594 3.76427 1.58594 3.83485V6.12652Z"
        fill="white"
        className={className}
      />
    </svg>
  );
};
